<template>
  <div class="models">
    <label @click="$router.push('/admin/home')" class="back">
      <figure>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
      </figure>
      <p>Ajuda</p>
    </label>
    <div class="header">
      <label class="search" for="search-document-subject">
        <input autocomplete='off' type="text" placeholder="Digite sua busca" id="search-document-subject" name="search-document-subject" @keyup.enter="search = new RegExp(`.*${($event.target as HTMLInputElement).value}.*`, 'i')">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M17.5002 17.5002L13.881 13.881M13.881 13.881C14.5001 13.2619 14.9912 12.527 15.3262 11.7181C15.6612 10.9093 15.8337 10.0423 15.8337 9.16684C15.8337 8.29134 15.6612 7.42441 15.3262 6.61555C14.9912 5.80669 14.5001 5.07174 13.881 4.45267C13.2619 3.8336 12.527 3.34252 11.7181 3.00748C10.9093 2.67244 10.0423 2.5 9.16684 2.5C8.29134 2.5 7.42441 2.67244 6.61555 3.00748C5.80669 3.34252 5.07174 3.8336 4.45267 4.45267C3.2024 5.70295 2.5 7.39868 2.5 9.16684C2.5 10.935 3.2024 12.6307 4.45267 13.881C5.70295 15.1313 7.39868 15.8337 9.16684 15.8337C10.935 15.8337 12.6307 15.1313 13.881 13.881Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </label>
      <div class="filters">
        <button class="tooltip">
          <figure>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 11V17L11 15" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 17L7 15" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </figure>
        </button>
      </div>
    </div>
    <div :class="['tab', tab]">
      <h1 @click="toggleTab('models')">Modelos</h1>
      <h1 @click="toggleTab('flow')">Fluxos</h1>
      <span></span>
    </div>
    <section v-if="!(models && !documentModels.length && Array.isArray(models) && !documentFlowModels.length) && tab == 'models'">
      <div class="itens" v-if="documentModels.length" :class="{lower: documentModels.length < 4}">
        <div class="item" :class="model.file_mime_type" v-for="model in documentModels">
          <div class="card">
            <h1>Documento word</h1>
            <h1>Documento PDF</h1>
            <img src="@/assets/images/word.png" alt="Imagem do tipo de arquivo do documento.">
            <img src="@/assets/images/adobe.png" alt="Imagem do tipo de arquivo do documento.">
            <div class="actions" v-if="model.file_mime_type !== ModelFileMimeTypeEnum.WORD">
              <button class="tooltip" @click="downloadFiles(model.files as ModelFileInterface[])">
                <figure>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path stroke="none" fill-rule="evenodd" clip-rule="evenodd" d="M11.9992 1.68018C12.1902 1.68018 12.3733 1.75603 12.5083 1.89106C12.6434 2.02609 12.7192 2.20922 12.7192 2.40018V13.4626L16.2904 9.89138C16.3563 9.82064 16.4358 9.7639 16.5241 9.72455C16.6125 9.68519 16.7078 9.66403 16.8045 9.66233C16.9012 9.66062 16.9972 9.67841 17.0868 9.71462C17.1765 9.75083 17.2579 9.80473 17.3263 9.8731C17.3947 9.94147 17.4486 10.0229 17.4848 10.1126C17.521 10.2022 17.5388 10.2982 17.5371 10.3949C17.5354 10.4916 17.5142 10.5869 17.4749 10.6753C17.4355 10.7636 17.3788 10.8431 17.308 10.909L12.508 15.709C12.373 15.8438 12.19 15.9195 11.9992 15.9195C11.8084 15.9195 11.6254 15.8438 11.4904 15.709L6.69042 10.909C6.61968 10.8431 6.56294 10.7636 6.52359 10.6753C6.48424 10.5869 6.46308 10.4916 6.46137 10.3949C6.45967 10.2982 6.47745 10.2022 6.51366 10.1126C6.54988 10.0229 6.60378 9.94147 6.67215 9.8731C6.74052 9.80473 6.82196 9.75083 6.91161 9.71462C7.00126 9.67841 7.09729 9.66062 7.19396 9.66233C7.29064 9.66403 7.38598 9.68519 7.4743 9.72455C7.56262 9.7639 7.64211 9.82064 7.70802 9.89138L11.2792 13.4626V2.40018C11.2792 2.20922 11.3551 2.02609 11.4901 1.89106C11.6251 1.75603 11.8083 1.68018 11.9992 1.68018ZM3.99922 16.0002C4.2114 16.0002 4.41488 16.0845 4.56491 16.2345C4.71494 16.3845 4.79922 16.588 4.79922 16.8002V19.2002C4.79922 20.0866 5.51282 20.8002 6.39282 20.8002H17.6008C17.8109 20.8002 18.0188 20.7588 18.2129 20.6784C18.4069 20.5979 18.5832 20.48 18.7316 20.3314C18.8801 20.1829 18.9978 20.0065 19.078 19.8123C19.1582 19.6182 19.1994 19.4102 19.1992 19.2002V16.8002C19.1992 16.588 19.2835 16.3845 19.4335 16.2345C19.5836 16.0845 19.787 16.0002 19.9992 16.0002C20.2114 16.0002 20.4149 16.0845 20.5649 16.2345C20.7149 16.3845 20.7992 16.588 20.7992 16.8002V19.2002C20.7992 20.0486 20.4623 20.8623 19.8625 21.4624C19.2628 22.0624 18.4492 22.3998 17.6008 22.4002H6.39282C5.97295 22.4 5.55724 22.317 5.16945 22.156C4.78167 21.9951 4.42941 21.7593 4.13281 21.4621C3.83622 21.1649 3.6011 20.8121 3.44091 20.424C3.28072 20.0359 3.19859 19.62 3.19922 19.2002V16.8002C3.19922 16.588 3.28351 16.3845 3.43354 16.2345C3.58357 16.0845 3.78705 16.0002 3.99922 16.0002Z"/>
                  </svg>
                </figure>
              </button>
              <button class="tooltip" @click="selectedModel = model; isModelModalOpen = true">
                <figure>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill="none" d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path fill="none" d="M11.9998 20.2702C15.5298 20.2702 18.8198 18.1902 21.1098 14.5902C22.0098 13.1802 22.0098 10.8102 21.1098 9.40021C18.8198 5.80021 15.5298 3.72021 11.9998 3.72021C8.46984 3.72021 5.17984 5.80021 2.88984 9.40021C1.98984 10.8102 1.98984 13.1802 2.88984 14.5902C5.17984 18.1902 8.46984 20.2702 11.9998 20.2702Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </figure>
              </button>
            </div>
            <div class="actions word" v-else>
              <button @click="downloadFiles(model.files as ModelFileInterface[])">
                <figure>
                  <h1>baixar</h1>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path stroke="none" fill-rule="evenodd" clip-rule="evenodd" d="M11.9992 1.68018C12.1902 1.68018 12.3733 1.75603 12.5083 1.89106C12.6434 2.02609 12.7192 2.20922 12.7192 2.40018V13.4626L16.2904 9.89138C16.3563 9.82064 16.4358 9.7639 16.5241 9.72455C16.6125 9.68519 16.7078 9.66403 16.8045 9.66233C16.9012 9.66062 16.9972 9.67841 17.0868 9.71462C17.1765 9.75083 17.2579 9.80473 17.3263 9.8731C17.3947 9.94147 17.4486 10.0229 17.4848 10.1126C17.521 10.2022 17.5388 10.2982 17.5371 10.3949C17.5354 10.4916 17.5142 10.5869 17.4749 10.6753C17.4355 10.7636 17.3788 10.8431 17.308 10.909L12.508 15.709C12.373 15.8438 12.19 15.9195 11.9992 15.9195C11.8084 15.9195 11.6254 15.8438 11.4904 15.709L6.69042 10.909C6.61968 10.8431 6.56294 10.7636 6.52359 10.6753C6.48424 10.5869 6.46308 10.4916 6.46137 10.3949C6.45967 10.2982 6.47745 10.2022 6.51366 10.1126C6.54988 10.0229 6.60378 9.94147 6.67215 9.8731C6.74052 9.80473 6.82196 9.75083 6.91161 9.71462C7.00126 9.67841 7.09729 9.66062 7.19396 9.66233C7.29064 9.66403 7.38598 9.68519 7.4743 9.72455C7.56262 9.7639 7.64211 9.82064 7.70802 9.89138L11.2792 13.4626V2.40018C11.2792 2.20922 11.3551 2.02609 11.4901 1.89106C11.6251 1.75603 11.8083 1.68018 11.9992 1.68018ZM3.99922 16.0002C4.2114 16.0002 4.41488 16.0845 4.56491 16.2345C4.71494 16.3845 4.79922 16.588 4.79922 16.8002V19.2002C4.79922 20.0866 5.51282 20.8002 6.39282 20.8002H17.6008C17.8109 20.8002 18.0188 20.7588 18.2129 20.6784C18.4069 20.5979 18.5832 20.48 18.7316 20.3314C18.8801 20.1829 18.9978 20.0065 19.078 19.8123C19.1582 19.6182 19.1994 19.4102 19.1992 19.2002V16.8002C19.1992 16.588 19.2835 16.3845 19.4335 16.2345C19.5836 16.0845 19.787 16.0002 19.9992 16.0002C20.2114 16.0002 20.4149 16.0845 20.5649 16.2345C20.7149 16.3845 20.7992 16.588 20.7992 16.8002V19.2002C20.7992 20.0486 20.4623 20.8623 19.8625 21.4624C19.2628 22.0624 18.4492 22.3998 17.6008 22.4002H6.39282C5.97295 22.4 5.55724 22.317 5.16945 22.156C4.78167 21.9951 4.42941 21.7593 4.13281 21.4621C3.83622 21.1649 3.6011 20.8121 3.44091 20.424C3.28072 20.0359 3.19859 19.62 3.19922 19.2002V16.8002C3.19922 16.588 3.28351 16.3845 3.43354 16.2345C3.58357 16.0845 3.78705 16.0002 3.99922 16.0002Z"/>
                  </svg>
                </figure>
              </button>
            </div>
          </div>
          <h2>{{ model.name }}</h2>
        </div>
      </div>
      <div v-else-if="models && !documentModels.length"></div>
      <SpinnerLoader v-else />
    </section>
    <section v-if="!(models && !documentModels.length && Array.isArray(models) && !documentFlowModels.length) && tab == 'flow'">
      <div class="itens" v-if="documentFlowModels.length" :class="{lower: documentFlowModels.length < 4}">
        <div class="item" :class="model.file_mime_type" v-for="model in documentFlowModels">
          <div class="card">
            <h1>Documento word</h1>
            <h1>Documento PDF</h1>
            <img src="@/assets/images/word.png" alt="Imagem do tipo de arquivo do documento.">
            <img src="@/assets/images/adobe.png" alt="Imagem do tipo de arquivo do documento.">
            <div class="actions" v-if="model.file_mime_type !== ModelFileMimeTypeEnum.WORD">
              <button class="tooltip" @click="downloadFiles(model.files as ModelFileInterface[])">
                <figure>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path stroke="none" fill-rule="evenodd" clip-rule="evenodd" d="M11.9992 1.68018C12.1902 1.68018 12.3733 1.75603 12.5083 1.89106C12.6434 2.02609 12.7192 2.20922 12.7192 2.40018V13.4626L16.2904 9.89138C16.3563 9.82064 16.4358 9.7639 16.5241 9.72455C16.6125 9.68519 16.7078 9.66403 16.8045 9.66233C16.9012 9.66062 16.9972 9.67841 17.0868 9.71462C17.1765 9.75083 17.2579 9.80473 17.3263 9.8731C17.3947 9.94147 17.4486 10.0229 17.4848 10.1126C17.521 10.2022 17.5388 10.2982 17.5371 10.3949C17.5354 10.4916 17.5142 10.5869 17.4749 10.6753C17.4355 10.7636 17.3788 10.8431 17.308 10.909L12.508 15.709C12.373 15.8438 12.19 15.9195 11.9992 15.9195C11.8084 15.9195 11.6254 15.8438 11.4904 15.709L6.69042 10.909C6.61968 10.8431 6.56294 10.7636 6.52359 10.6753C6.48424 10.5869 6.46308 10.4916 6.46137 10.3949C6.45967 10.2982 6.47745 10.2022 6.51366 10.1126C6.54988 10.0229 6.60378 9.94147 6.67215 9.8731C6.74052 9.80473 6.82196 9.75083 6.91161 9.71462C7.00126 9.67841 7.09729 9.66062 7.19396 9.66233C7.29064 9.66403 7.38598 9.68519 7.4743 9.72455C7.56262 9.7639 7.64211 9.82064 7.70802 9.89138L11.2792 13.4626V2.40018C11.2792 2.20922 11.3551 2.02609 11.4901 1.89106C11.6251 1.75603 11.8083 1.68018 11.9992 1.68018ZM3.99922 16.0002C4.2114 16.0002 4.41488 16.0845 4.56491 16.2345C4.71494 16.3845 4.79922 16.588 4.79922 16.8002V19.2002C4.79922 20.0866 5.51282 20.8002 6.39282 20.8002H17.6008C17.8109 20.8002 18.0188 20.7588 18.2129 20.6784C18.4069 20.5979 18.5832 20.48 18.7316 20.3314C18.8801 20.1829 18.9978 20.0065 19.078 19.8123C19.1582 19.6182 19.1994 19.4102 19.1992 19.2002V16.8002C19.1992 16.588 19.2835 16.3845 19.4335 16.2345C19.5836 16.0845 19.787 16.0002 19.9992 16.0002C20.2114 16.0002 20.4149 16.0845 20.5649 16.2345C20.7149 16.3845 20.7992 16.588 20.7992 16.8002V19.2002C20.7992 20.0486 20.4623 20.8623 19.8625 21.4624C19.2628 22.0624 18.4492 22.3998 17.6008 22.4002H6.39282C5.97295 22.4 5.55724 22.317 5.16945 22.156C4.78167 21.9951 4.42941 21.7593 4.13281 21.4621C3.83622 21.1649 3.6011 20.8121 3.44091 20.424C3.28072 20.0359 3.19859 19.62 3.19922 19.2002V16.8002C3.19922 16.588 3.28351 16.3845 3.43354 16.2345C3.58357 16.0845 3.78705 16.0002 3.99922 16.0002Z"/>
                  </svg>
                </figure>
              </button>
              <button class="tooltip" @click="selectedModel = model; isModelModalOpen = true">
                <figure>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill="none" d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path fill="none" d="M11.9998 20.2702C15.5298 20.2702 18.8198 18.1902 21.1098 14.5902C22.0098 13.1802 22.0098 10.8102 21.1098 9.40021C18.8198 5.80021 15.5298 3.72021 11.9998 3.72021C8.46984 3.72021 5.17984 5.80021 2.88984 9.40021C1.98984 10.8102 1.98984 13.1802 2.88984 14.5902C5.17984 18.1902 8.46984 20.2702 11.9998 20.2702Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </figure>
              </button>
            </div>
            <div class="actions word" v-else>
              <button @click="downloadFiles(model.files as ModelFileInterface[])">
                <figure>
                  <h1>baixar</h1>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path stroke="none" fill-rule="evenodd" clip-rule="evenodd" d="M11.9992 1.68018C12.1902 1.68018 12.3733 1.75603 12.5083 1.89106C12.6434 2.02609 12.7192 2.20922 12.7192 2.40018V13.4626L16.2904 9.89138C16.3563 9.82064 16.4358 9.7639 16.5241 9.72455C16.6125 9.68519 16.7078 9.66403 16.8045 9.66233C16.9012 9.66062 16.9972 9.67841 17.0868 9.71462C17.1765 9.75083 17.2579 9.80473 17.3263 9.8731C17.3947 9.94147 17.4486 10.0229 17.4848 10.1126C17.521 10.2022 17.5388 10.2982 17.5371 10.3949C17.5354 10.4916 17.5142 10.5869 17.4749 10.6753C17.4355 10.7636 17.3788 10.8431 17.308 10.909L12.508 15.709C12.373 15.8438 12.19 15.9195 11.9992 15.9195C11.8084 15.9195 11.6254 15.8438 11.4904 15.709L6.69042 10.909C6.61968 10.8431 6.56294 10.7636 6.52359 10.6753C6.48424 10.5869 6.46308 10.4916 6.46137 10.3949C6.45967 10.2982 6.47745 10.2022 6.51366 10.1126C6.54988 10.0229 6.60378 9.94147 6.67215 9.8731C6.74052 9.80473 6.82196 9.75083 6.91161 9.71462C7.00126 9.67841 7.09729 9.66062 7.19396 9.66233C7.29064 9.66403 7.38598 9.68519 7.4743 9.72455C7.56262 9.7639 7.64211 9.82064 7.70802 9.89138L11.2792 13.4626V2.40018C11.2792 2.20922 11.3551 2.02609 11.4901 1.89106C11.6251 1.75603 11.8083 1.68018 11.9992 1.68018ZM3.99922 16.0002C4.2114 16.0002 4.41488 16.0845 4.56491 16.2345C4.71494 16.3845 4.79922 16.588 4.79922 16.8002V19.2002C4.79922 20.0866 5.51282 20.8002 6.39282 20.8002H17.6008C17.8109 20.8002 18.0188 20.7588 18.2129 20.6784C18.4069 20.5979 18.5832 20.48 18.7316 20.3314C18.8801 20.1829 18.9978 20.0065 19.078 19.8123C19.1582 19.6182 19.1994 19.4102 19.1992 19.2002V16.8002C19.1992 16.588 19.2835 16.3845 19.4335 16.2345C19.5836 16.0845 19.787 16.0002 19.9992 16.0002C20.2114 16.0002 20.4149 16.0845 20.5649 16.2345C20.7149 16.3845 20.7992 16.588 20.7992 16.8002V19.2002C20.7992 20.0486 20.4623 20.8623 19.8625 21.4624C19.2628 22.0624 18.4492 22.3998 17.6008 22.4002H6.39282C5.97295 22.4 5.55724 22.317 5.16945 22.156C4.78167 21.9951 4.42941 21.7593 4.13281 21.4621C3.83622 21.1649 3.6011 20.8121 3.44091 20.424C3.28072 20.0359 3.19859 19.62 3.19922 19.2002V16.8002C3.19922 16.588 3.28351 16.3845 3.43354 16.2345C3.58357 16.0845 3.78705 16.0002 3.99922 16.0002Z"/>
                  </svg>
                </figure>
              </button>
            </div>
          </div>
          <h2>{{ model.name }}</h2>
        </div>
      </div>
      <div class="no-models" v-else-if="Array.isArray(models) && !documentFlowModels.length"></div>
      <SpinnerLoader v-else />
    </section>

    <div class="no-options full" v-if="(tab == 'models' && models && !documentModels.length) || (tab == 'flow' && models && !documentFlowModels.length)">
      <svg xmlns="http://www.w3.org/2000/svg" width="173" height="173" viewBox="0 0 173 173" fill="none">
        <path opacity="0.4" d="M116.702 14.4166H56.2964C30.0581 14.4166 14.416 30.0587 14.416 56.297V116.631C14.416 142.941 30.0581 158.583 56.2964 158.583H116.63C142.869 158.583 158.511 142.941 158.511 116.703V56.297C158.583 30.0587 142.941 14.4166 116.702 14.4166Z" fill="#292D32"/>
        <path d="M113.531 70.2812H59.4688C56.5133 70.2812 54.0625 67.8304 54.0625 64.875C54.0625 61.9196 56.5133 59.4688 59.4688 59.4688H113.531C116.487 59.4688 118.938 61.9196 118.938 64.875C118.938 67.8304 116.487 70.2812 113.531 70.2812Z" fill="#292D32"/>
        <path d="M113.531 113.531H59.4688C56.5133 113.531 54.0625 111.08 54.0625 108.125C54.0625 105.17 56.5133 102.719 59.4688 102.719H113.531C116.487 102.719 118.938 105.17 118.938 108.125C118.938 111.08 116.487 113.531 113.531 113.531Z" fill="#292D32"/>
      </svg>
      <h1 v-if="tab == 'models'">Sem modelos por aqui.</h1>
      <h1 v-else>Sem fluxos por aqui.</h1>
    </div>

    <nav :class="{active: isMobileOptionsFilterOpen}" @click="toggleOverflow" class="action-filters">
      <button @click.stop @click="toggleOverflow()">
        <figure>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 11V17L11 15" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 17L7 15" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </figure>
      </button>
      <button>
        <figure>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M7 7L17 17M7 17L17 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </figure>
      </button>
    </nav>

    <MyModal v-if="selectedModel" :isOpen="isModelModalOpen" :class="'docView'" :toggleModal="(v: boolean) => isModelModalOpen = v" :width="'80rem'" :height="'50rem'" :zIndex='10'>
      <div v-if="selectedFilesSrc.length">
        <iframe v-for="src in selectedFilesSrc" :src="src" width="100%" height="100%"></iframe>
      </div>
      <SpinnerLoader v-else-if="selectedModel.files.length" />
      <p>{{ selectedModel?.description}}</p>
    </MyModal>
  </div>
</template>

<script setup lang="ts">
import { useAxios } from '@/api/axios'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import MyModal from '@/components/modal/MyModal.vue'
import ModelTypeEnum from '@/enums/ModelTypeEnum'
import ModelInterface, { ModelFileInterface } from '@/models/ModelInterface'
import { AxiosResponse } from 'axios'
import { computed, onMounted, ref, watch } from 'vue'
import ModelFileMimeTypeEnum from '@/enums/ModelFileMimeTypeEnum'

const search = ref(new RegExp('.*.*', 'i'))
const axios = useAxios()
const models = ref<ModelInterface[]>()
const documentModels = computed(() => (models.value ?? []).filter((model) => model.type == ModelTypeEnum.DOCUMENT_MODEL && search.value.test(model.name)))
const documentFlowModels = computed(() => (models.value ?? []).filter((model) => model.type == ModelTypeEnum.FLOW_MODEL && search.value.test(model.name)))
const isModelModalOpen = ref(false)
const selectedModel = ref<ModelInterface>()
const selectedFilesSrc = ref<string[]>([])
const isMobileOptionsFilterOpen = ref<boolean>(false)

const tab = ref<string>('models')

const toggleTab = (type: string) => {
  tab.value = type;
};

const toggleOverflow = () => {
  isMobileOptionsFilterOpen.value = !isMobileOptionsFilterOpen.value
  document.body.style.overflow = isMobileOptionsFilterOpen.value ? 'hidden' : 'auto'
}

async function loadSelectedModelFiles () {
  if (selectedModel.value?.files) {
    const sources = await Promise.all(
      selectedModel.value.files.map(async (file) => {
        return await visualizeFile(file as ModelFileInterface)
      })
    )
    selectedFilesSrc.value = sources
  }
}

async function visualizeFile (file: ModelFileInterface): Promise<string> {
  try {
    const response = await axios.get(`/api/models/get-file-content/${file.id}`, { responseType: 'blob' })
    return URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }))
  } catch (error) {
    console.error('Erro ao buscar o documento:', error)
    return ''
  }
}

watch(selectedModel, async () => {
  await loadSelectedModelFiles()
}, { deep: true, immediate: true })

function getModels () {
  axios.get('/api/models')
    .then((res: AxiosResponse<ModelInterface[]>) => {
      models.value = res.data
    })
}

function downloadFiles (files: ModelFileInterface[]): void {
  files.forEach((file) => {
    axios.get(`/api/models/get-file-content/${file.id}`, { responseType: 'blob' })
      .then(response => {
        const url = URL.createObjectURL(new Blob([response.data]))

        const link = window.document.createElement('a')
        link.href = url
        link.setAttribute('download', file.name)
        link.style.display = 'none'
        window.document.body.appendChild(link)
        link.click()
        window.document.body.removeChild(link)
      })
      .catch(error => {
        console.error('Erro ao buscar o documento:', error)
      })
  })
}

onMounted(() => {
  getModels()
})
</script>

<style lang="scss">

  .no-models{
    h1{
      color: #080808;
      font-family: 'Inter', sans-serif;
      font-size: 19px !important;
      font-style: normal;
      font-weight: 500 !important;
      line-height: normal;
      margin: 10px 0 0 0;
      text-align: center;
    }
  }

  .models{
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 0;
    .header{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 20px;
    .search{
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      input{
          width: 100%;
          height: 55px;
          border: none;
          border-radius: 16px;
          background: #F5F5F5;
          color: $fluxoo-primary-color;
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          padding: 20px 56px 20px 20px;
          box-sizing: border-box;
          transition: background .2s;
          &:focus{
              outline: none;
              &::placeholder{
                color: transparent
              }
              & ~ svg{
                stroke: $fluxoo-primary-color;
              }
          }
          &::placeholder{
              color: #090909;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
          }
          &:read-only{
              cursor: default !important;
          }
      }
      svg{
          width: 20px;
          min-width: 20px;
          height: 20px;
          min-height: 20px;
          position: absolute;
          right: 20px;
          stroke: #090909;
          cursor: pointer;
      }
    }
    .filters{
      display: flex;
      align-items: center;
      column-gap: 15px;
      button{
        width: 50px;
        height: 50px;
        border-radius: 12px;
        border: 1px solid #D5D5D5;
        transition: border-color .2s;
        cursor: pointer;
        &:hover{
          border-color: $fluxoo-primary-color;
          outline: 1px solid $fluxoo-primary-color;
          svg{
            stroke: $fluxoo-primary-color;
          }
        }
        figure{
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0;
          svg{
            width: 24px;
            min-width: 24px;
            height: 24px;
            min-height: 24px;
            stroke: #090909;
            transition: stroke .2s;
          }
        }
        &:nth-child(1)::before{
          content: 'Baixar todos';
          width: 102px;
          right: -5px;
        }
        &:nth-child(2)::before{
          content: 'Filtros gerais';
          width: 105px;
          right: -2px;
        }
      }
    }
    }
    .tab{
      min-height: 28px;
      display: flex;
      flex-direction: row;
      align-items: start;
      column-gap: 32px;
      margin: 48px auto 0 0;
      padding: 0;
      position: relative;
      span{
        display: flex;
        height: 3px;
        width: 75px;
        background: $fluxoo-primary-color;
        position: absolute;
        bottom: 0;
        left: 0;
        transition: left .2s;
      }
      h1{
        color: #090909;
        font-family: 'Inter', sans-serif;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin: 0;
        cursor: pointer;
        transition: color .2s, margin .2s;
        &:hover{
          color: $fluxoo-primary-color;
        }
      }
      &.models{
        h1:nth-child(1){
          color: $fluxoo-primary-color;
          cursor: default;
        }
        span{
          left: 0;
        }
      }
      &.flow{
        h1:nth-child(2){
          color: $fluxoo-primary-color;
          cursor: default;
        }
        span{
          width: 58px;
          left: 105px;
        }
      }
    }
    .action-filters{
      display: none;
    }
    section{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: start;
      row-gap: 10px;
      &:nth-child(4){
        margin: 32px 0 50px 0;
      }
      h1{
        color: #090909;
        font-family: 'Nunito', sans-serif;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin: 0;
      }
      .itens{
        width: 100%;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(183px, 1fr));
        justify-content: start;
        column-gap: 20px;
        row-gap: 40px;
        &.lower{
          grid-template-columns: repeat(auto-fit, 285px);
        }
        .item{
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          .card{
            width: 100%;
            height: 265px;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 48px 20px 27px;
            margin: 0 0 12px 0;
            row-gap: 16px;
            border-radius: 24px;
            background: #F5F5F5;
            box-sizing: border-box;
            transition: background .2s;
            &:hover{
              background: #E0ECE9;
            }
            h1{
              display: none;
              color: #090909;
              font-family: 'Nunito', sans-serif;
              font-size: 16px;
              font-style: normal;
              font-weight: 700;
              line-height: normal;
              margin: 0;
              transition: color .2s;
            }
            img{
              display: none;
              widows: 80px;
              min-width: 80px;
              height: 80px;
              min-height: 80px;
              margin: 0 0 12px 0;
            }
            .actions{
              width: 128px;
              display: flex;
              align-items: center;
              justify-content: center;
              column-gap: 48px;
              button{
                width: 45px;
                min-width: 45px;
                height: 45px;
                min-height: 45px;
                border-radius: 50%;
                background: transparent;
                transition: background .2s;
                cursor: pointer;
                &.tooltip:nth-child(1){
                  &::before{
                      content: 'Baixar';
                      width: 63px;
                  }
                }
                &:nth-child(2){
                    &::before{
                        content: 'Visualizar';
                        width: 83px;
                    }
                }
                &:hover{
                  figure{
                    background: $fluxoo-primary-color;
                    svg{
                      stroke: #FFF;
                      fill: #FFF;
                    }
                  }
                }
                figure{
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin: 0;
                  background: #FFF;
                  border-radius: 50%;
                  transition: background .2s;
                  filter: drop-shadow(0px 0px 32px rgba(0, 0, 0, 0.15));
                  svg{
                    width: 24px;
                    min-width: 24px;
                    height: 24px;
                    min-height: 24px;
                    stroke: #090909;
                    fill: #090909;
                    transition: stroke .2s, fill .2s;
                  }
                  &:hover{
                    background: $fluxoo-primary-color;
                  }
                }
              }
              &.word{
                width: 100%;
                button{
                  width: 100%;
                  figure{
                    border-radius: 50px;
                    column-gap: 10px;
                    display: flex;
                    align-items: center;
                    h1{
                      transition: color .2s;
                    }
                    svg{
                      width: 22px;
                      min-width: 22px;
                      height: 22px;
                      min-height: 22px;
                    }
                    &:hover{
                      h1{
                        color: #FFF;
                      }
                    }
                  }
                }
              }
            }
          }
          h2{
            color: #090909;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            margin: 0 auto 0 0;
          }
          &.pdf{
            .card{
              h1:nth-child(even){
                display: flex;
              }
              img:nth-child(even){
                display: flex;
                margin: 0 0 12px 0;
              }
            }
          }
          &.word{
            .card{
              h1:nth-child(odd){
                display: flex;
              }
              img:nth-child(odd){
                display: flex;
              }
            }
          }
        }
      }
    }
    .modal{
      &.docView{
        .modal__content{
          padding: 0;
        }
        div{
          height: 100%;
        }
        p{
          display: none;
        }
      }
    }
  }

  @media(max-width: 768px){
    .models{
      .header{
        .filters{
          display: none;
        }
      }
      .action-filters{
        display: flex;
        display: flex;
        flex-direction: column;
        justify-content: end;
        align-items: end;
        row-gap: 8px;
        position: fixed;
        bottom: 15px;
        right: 15px;
        z-index: 4;
        box-sizing: border-box;
        transition: opacity 0.3s;
        &.active{
          width: 100vw;
          height: 100dvh;
          display: flex;
          flex-direction: column;
          justify-content: end;
          align-items: end;
          row-gap: 8px;
          position: fixed;
          background: #292F3150;
          top: 0;
          bottom: unset;
          right: unset;
          left: 0;
          z-index: 4;
          padding: 15px;
          box-sizing: border-box;
          button{
            display: flex;
            align-items: center;
            justify-content: center;
            animation: enterContent ease .4s;
            &:last-child{
              figure{
                svg{
                  transform: rotate(0);
                }
              }
            }
          }
        }
        button{
          display: none;
          width: 45px;
          min-width: 45px;
          height: 45px;
          min-height: 45px;
          background: #FFF;
          border-radius: 50%;
          transition: background .2s;
          filter: drop-shadow(0px 0px 25px rgba(0, 0, 0, 0.15));
          cursor: pointer;
          &:hover{
            background: $fluxoo-primary-color;
            figure{
              svg{
                stroke: #FFF;
              }
            }
          }
          figure{
            widows: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0;
            svg{
              width: 20px;
              min-width: 20px;
              height: 20px;
              min-height: 20px;
              stroke: #090909;
              transition: stroke .2s;
            }
          }
          &:last-child{
            display: flex;
            align-items: center;
            justify-content: center;
            background: $fluxoo-primary-color;
            figure{
              svg{
                stroke: #FFF;
                margin: 0 0 0 -1px;
                transform: rotate(-405deg);
                transition: transform .2s, background .2s;
              }
            }
            &:hover{
              background: $fluxoo-primary-color-hover;
            }
          }
        }
      }
    }
  }

  @media(max-width: 425px){
    .manage-document-subjects{
      .action-filters{
        bottom: 15px;
        &.active{
          padding-bottom: 15px;
        }
      }
    }
  }
</style>
